import { useQuery } from "react-query";
import {
    GetShiftNowResponse,
    ParamsGetShiftNow,
} from "../../constants/types";
import axios from "../axios";

const queryString = require("query-string");

const handleRequest = async (params: ParamsGetShiftNow) => {
    const apiGetShiftNow = queryString.stringifyUrl({
        url: "/api/shift-get",
        query: {
            ukmId: params.ukmId,
            tipe: params.tipe,
        },
    });
    const { data } = await axios.get<GetShiftNowResponse>(apiGetShiftNow);
    return data.data;
};

export default function useListInvoice(params: ParamsGetShiftNow) {
    return useQuery<GetShiftNowResponse["data"]>(
        ["shiftNow", params],
        () => handleRequest(params),
    );
}
